import React, { Component } from "react";
import StoreOverrideForm from "../StoreOverrideForm";
import { Breadcrumbs, BreadcrumbsItem, Display2 } from "@sainsburys-tech/fable";
import { styles } from "./StoreOverridePage.styles";
import PageTitle from "../PageTitle";
import { Link } from "react-router-dom";
import { OverrideToastConsumer } from "../WithOverrideToastManager";
import { Navigate } from "react-router-dom";
import withLoadingAndErrorHandling from "../../utils/reactive/wrapPageApiCall.js";
import { forkJoin } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import { componentFromStream } from "recompose";
import moment from "moment";
import * as zoneTypeKeys from "../../model/lighting-zone-types/zoneTypeKeys.js";
import { Event } from "../Tracking";
import apiProxy from "../../api/apiProxy";
import {
  OCCURS_ONCE,
  REPEATS_DAILY
} from "../../model/lighting-overrides/overrideFrequencyKeys";

class StoreOverridePage extends Component {
  state = {
    initialValues: {
      overrideName: "",
      storeId: null,
      selectedStores: [],
      scene: "",
      selectedZones: [],
      allZonesSelected: false,
      startTime: "",
      startDate: null,
      endTime: "",
      endDate: null,
      startDateFocused: false,
      endDateFocused: false,
      endTimeOptions: [],
      occurOnceOrRepeatDaily: OCCURS_ONCE,
      activeDays: [
        { name: "Monday", checked: true },
        { name: "Tuesday", checked: true },
        { name: "Wednesday", checked: true },
        { name: "Thursday", checked: true },
        { name: "Friday", checked: true },
        { name: "Saturday", checked: true },
        { name: "Sunday", checked: true }
      ]
    },
    zones: [],
    selectedStore: null,
    redirectToOverridesPage: false
  };

  handleRetrieveZones = (storeId, selectedStore) => {
    return apiProxy.storeLighting.getStore(storeId).then(store => {
      this.setState({
        zones: mapZones(store.storeConfiguration),
        selectedStore: selectedStore
      });
    });
  };

  handleRetrieveAllStoresZones = selectedStore => {
    return apiProxy.storeLighting.getLatestStoreZones().then(storeZones => {
      let allZones = [];
      storeZones.storeZones.map(zones => {
        return (allZones = allZones.concat(mapZones(zones)));
      });
      const uniqueZones = Array.from(new Set(allZones.map(JSON.stringify))).map(
        JSON.parse
      );
      this.setState({
        zones: uniqueZones,
        selectedStore: selectedStore
      });
    });
  };

  handleStoreDeselect = () => {
    this.setState({
      selectedStore: null,
      zones: []
    });
  };

  handleSubmit = values => {
    const name = values.overrideName;
    const stores = [];

    if (values.selectedStores.length !== 0) {
      const storeIds = values.selectedStores.map(st => st.storeId);
      stores.push(...storeIds);
    } else {
      stores.push(values.storeId);
    }

    const scene = values.scene;
    const zones = [];

    if (!values.allZonesSelected) {
      values.selectedZones.map(zone => {
        return zones.push(zone.zoneId);
      });
    }

    const allZonesSelected = values.allZonesSelected;

    const isRecurring = values.occurOnceOrRepeatDaily === REPEATS_DAILY;

    const daysOfWeek = [];

    if (isRecurring) {
      values.activeDays
        .filter(d => d.checked === true)
        .map(d => {
          return daysOfWeek.push(d.name);
        });
    }

    const startTime = values.startTime;

    const startDate = moment(values.startDate)
      .format()
      .substring(
        0,
        moment(values.startDate)
          .format()
          .indexOf("T")
      );

    const start = startDate + "T" + startTime + ":00";

    const endTime = values.endTime.split(" ")[0];

    const endDate = moment(values.endDate)
      .format()
      .substring(
        0,
        moment(values.endDate)
          .format()
          .indexOf("T")
      );

    const end = endDate + "T" + endTime + ":00";

    return apiProxy.storeLighting.createOverride(
      name,
      stores,
      zones,
      allZonesSelected,
      scene,
      start,
      end,
      daysOfWeek,
      isRecurring
    );
  };

  redirectToOverridesPage = () => {
    this.setState({ redirectToOverridesPage: true });
  };

  handleSaveComplete = overrides => {
    const override = overrides[0];
    this.props.toastManager.add(
      "success",
      "Override configured",
      `${override.name} has been added. We'll notify you when the store has received the override.`
    );
    this.props.toastManager.monitorOverrideStage(
      override.overrideId,
      override.name
    );
    Event("Override Event", "Override Saved", "(not set)");
    this.redirectToOverridesPage();
  };

  render() {
    if (this.state.redirectToOverridesPage) {
      return <Navigate to="/lighting/overrides" replace />
    }
    const zonesDisabled = this.state.selectedStore == null;
    return (
      <PageTitle title="Create store override">
        <fieldset style={{ border: 'none', padding: 0, margin: 0 }}>
          <div style={{
            backgroundColor: "#ffffff",
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            padding: "24px",
            borderRadius: "4px"
          }}>
          <Breadcrumbs colourScheme="dark">
            <BreadcrumbsItem href="/lighting/overrides">Lighting overrides</BreadcrumbsItem>
            <BreadcrumbsItem href="/lighting/overrides/add" aria-current="page" style={{ fontWeight: "bold", color: "#000000" }}>Create override</BreadcrumbsItem>
          </Breadcrumbs>

          <div className="fable:mb-2">
            <Display2 style={styles.display2}>Create override</Display2>
          </div>

          <StoreOverrideForm
            handleStoreSelect={this.handleStoreSelect}
            handleDateChange={this.handleDateChange}
            handleDateFocus={this.handleDateFocus}
            startDate={this.state.startDate}
            startDateFocused={this.state.startDateFocused}
            endDate={this.state.endDate}
            endDateFocused={this.state.endDateFocused}
            initialValues={this.state.initialValues}
            zones={this.state.zones}
            handleRetrieveZones={this.handleRetrieveZones}
            handleRetrieveAllStoresZones={this.handleRetrieveAllStoresZones}
            selectedStore={this.state.selectedStore}
            startTime={this.state.startTime}
            scenes={this.props.scenes}
            onSubmit={this.handleSubmit}
            onSelect={this.handleOnSelect}
            handleStoreDeselect={this.handleStoreDeselect}
            onSaveComplete={overrides => this.handleSaveComplete(overrides)}
            onCancel={this.redirectToOverridesPage}
            zonesDisabled={zonesDisabled}
            handleEndDateSelection={this.handleEndDateSelection}
          />
          </div>
        </fieldset>
      </PageTitle>
    );
  }
}

const mapZones = zones => {
  return zones.zones
    .filter(f => f.zone.zoneType === zoneTypeKeys.CBUS)
    .map(zone => {
      return {
        zoneId: zone.zone.zoneId,
        name: zone.zone.name,
        zoneRef: zone.zone.zoneRef
      };
    });
};

const mapScenes = scenes => {
  if (scenes.scenes != null) {
    return scenes.scenes.map(scene => {
      return {
        value: scene.name,
        label: scene.description
      };
    });
  }
};

export default componentFromStream(props$ => {
  return withLoadingAndErrorHandling(() =>
    props$.pipe(
      mergeMap(({ getScenes }) => forkJoin([getScenes()])),
      map(([scenes]) => (
        <OverrideToastConsumer>
          {toastManagerContext => (
            <StoreOverridePage
              toastManager={toastManagerContext}
              scenes={mapScenes(scenes)}
            />
          )}
        </OverrideToastConsumer>
      ))
    )
  );
});
